import React, { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useFirebaseEvent } from 'hooks'
import { setDrawerAlert } from 'slices/drawer'
import { setModal } from 'slices/modal'
import {
  DEFAULT_ERROR_MESSAGE,
  RIBEIRAO_PRETO_UNITY,
  RIBEIRAO_PRETO_WHATS_APP,
  PHONE_NUMBER,
  EVENT_STATUS,
  MODAL_KEYS,
} from 'app-constants'
import { STATICS } from 'statics'
import { sendWhatsappMessage } from 'utils'
import { uploadService } from 'services'
import { ContextLoader } from 'components/context-loader'
import { Button } from 'components/button'
import { EVENTS, STATUS } from './constants'
import './style.scss'

export function FileUploadModal() {
  const [isLoading, setIsLoading] = useState(false)
  const [status, setStatus] = useState(STATUS.INITIAL)
  const inputFileEl = useRef(null)
  const { selected: selectedContract } = useSelector(({ contract }) => contract)
  const { data } = useSelector(({ modal }) => modal)
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()
  const { uploadFile } = uploadService()

  async function handleSubmit() {
    const events = getEvents()

    setIsLoading(true)
    sendEvent(events.UPLOAD)

    try {
      const file = inputFileEl.current.files[0]

      await uploadFile(selectedContract.id, file)
      sendEvent(events.SUCCESS, EVENT_STATUS.SUCCESS)
      setStatus(STATUS.SUCCESS)
    } catch (error) {
      const errorMessage = error?.response?.data?.message || DEFAULT_ERROR_MESSAGE

      console.error(error)
      setStatus(STATUS.ERROR)
      sendEvent(events.ERROR, EVENT_STATUS.ERROR, error?.response?.status)
      dispatch(setDrawerAlert({ severity: 'error', title: errorMessage }))
    }

    setIsLoading(false)
  }

  function renderLoading() {
    return <ContextLoader fixed={false} />
  }

  function handleOpenChat() {
    dispatch(setModal({ key: MODAL_KEYS.NONE }))
    sendWhatsappMessage({})
  }

  const content = {
    [STATUS.INITIAL]: {
      icon: <STATICS.ROUNDED_RECEIPT />,
      backgroundColor: 'blue',
      text: `*Arquivos suportados: Imagem e PDF\n*Tamanho Máximo: 4Mb`,
      title: 'Envio de arquivo',
      button: (
        <label className='file'>
          Selecionar arquivo
          <input
            name='file'
            className='input'
            ref={inputFileEl}
            onChange={handleSubmit}
            type='file'
            accept='image/*,pdf/*'
          />
        </label>
      ),
    },
    [STATUS.SUCCESS]: {
      icon: <STATICS.DONE />,
      backgroundColor: 'green',
      title: 'Anexo enviado com sucesso',
      button: (
        <>
          <Button
            className='button'
            color='primary'
            size='large'
            onClick={() => dispatch(setModal({ key: MODAL_KEYS.NONE }))}
          >
            Ok
          </Button>
          <Button className='button' color='primary' size='large' onClick={() => handleOpenChat()}>
            Falar com atendimento
          </Button>
        </>
      ),
    },
    [STATUS.ERROR]: {
      icon: <STATICS.CLOSE />,
      backgroundColor: 'red',
      text: `Lembre-se de enviar um formato de arquivo válido (imagem ou PDF) ao tentar novamente ou se preferir ligue na central de atendimento ${getPhoneNumber()}, atendemos todos dos dias, 24 horas.`,
      title: 'Houve um erro inesperado e não foi concluída a sua solicitação',
      button: (
        <Button
          className='button'
          color='primary'
          size='large'
          onClick={() => dispatch(setModal({ key: MODAL_KEYS.NONE }))}
        >
          Ok, entendi
        </Button>
      ),
    },
  }

  function getPhoneNumber() {
    if (selectedContract?.unity === RIBEIRAO_PRETO_UNITY) {
      return RIBEIRAO_PRETO_WHATS_APP
    }

    return PHONE_NUMBER
  }

  function getEvents() {
    return data?.isUnduePayment ? EVENTS.UNDUE_PAYMENT_FILE_UPLOAD : EVENTS.FILE_UPLOAD
  }

  function renderContent() {
    return (
      <>
        <div className={`round -${content[status].backgroundColor}`}>
          <div className='icon'>{content[status].icon}</div>
        </div>
        <h3 className='title'>{content[status].title}</h3>
        <p className='text'>{content[status].text}</p>
        {content[status].button}
      </>
    )
  }

  return <div className='file-upload-modal'>{isLoading ? renderLoading() : renderContent()}</div>
}
